import { ErrorState, type ErrorStateProps, Stack } from '@pie/amber';

type PageErrorProps = ErrorStateProps;

export function PageError(props: PageErrorProps) {
  return (
    <Stack className="min-h-full" direction="column" justify="center">
      <ErrorState
        media={
          // eslint-disable-next-line @next/next/no-img-element
          <img alt="" height={128} src="/illustrations/pie.svg" width={184} />
        }
        size="lg"
        {...props}
      />
    </Stack>
  );
}
